import { combineReducers } from 'redux';
import { userReducer, loginReducer, sessionidentifierReducer, getcategorydataReducer, logoutReducer, LahloobEorderReducer, EorderReducer, formReducer, dashDataReducer, storeReducer, permissionsReducer, geneLoginReducer } from "./index"
import deliveryAreasSlice from '../../components/Redux Slices/deliveryAreasSlice';
import { store } from '../store';


const rootReducer = combineReducers({
  user: userReducer,
  login: loginReducer,
  // sessionIdentify:sessionidentifierReducer,
  // productData:getcategorydataReducer,
  logout: logoutReducer,
  EorderReducer: EorderReducer,
  form: formReducer,
  dashData: dashDataReducer,
  LahloobEorderReducer: LahloobEorderReducer,
  storeReducer: storeReducer,
  permissionsReducer: permissionsReducer,
  geneLoginReducer: geneLoginReducer,
  // deliveryAreas:deliveryAreasSlice,
});

export default rootReducer;
